import { CommonModule, DatePipe } from '@angular/common';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { CUSTOM_ELEMENTS_SCHEMA, Component, Inject, Renderer2, TemplateRef, ViewChild } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { EncrDecrService } from '@mysrc/app/Providers/EncrDecrService';
import { BaseHttpReqRespService } from '@mysrc/app/modules/fwcore/services';
import { NgbModal, NgbModalRef, NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { OKTA_AUTH } from '@okta/okta-angular';
import OktaAuth from '@okta/okta-auth-js';
import { GridModule } from '@progress/kendo-angular-grid';
import { AgGridAngular } from 'ag-grid-angular';
import * as XLSX from 'xlsx';
import { oktaToken } from '../../../../models/okta-token.model';
import { childQuestionsToExprot } from '../../models/child-questions-to-export.model';
import { mainQuestion } from '../../models/main-question.model';
import { mainQuestionsToExport } from '../../models/main-questions-to-export.model';
import { question } from '../../models/question.model';
import { CommonService } from '../../services/commonservice';
import { QuestionService } from '../../services/questionservice';

// Import ISG Shared Components
import { IsgGridComponent } from '@mysrc/app/shared/components/isg-grid';
import { IsgGridConfig } from '@mysrc/app/shared/models/grid-config.model';
import { dateValueFormatter } from '@mysrc/app/shared/utils/date-formatter';

@Component({
  selector: 'question',
  standalone: true,
  imports: [CommonModule, ReactiveFormsModule, GridModule, NgbModule, AgGridAngular, IsgGridComponent],
  templateUrl: './page-question.component.html',
  styleUrls: ['./page-question.component.css'],
  providers: [CommonService, QuestionService, DatePipe],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class PageQuestionComponent extends BaseHttpReqRespService {
  modalRef: NgbModalRef | undefined;
  success: boolean = false;
  public questionNew!: question;
  public mainQuestionList!: mainQuestion[];
  public folderList!: mainQuestion[];
  public questionList!: mainQuestion[];
  public exportQuestionList!: mainQuestion[];
  public mainQuestionListToExport!: mainQuestionsToExport[];
  public childQuestionListToExport!: childQuestionsToExprot[];
  public questionsToExport: string[] = [];
  public questionsToDelete: string[] = [];
  arrayBuffer: any;
  file: File | null = null;
  myAppUrl: any;

  errorMessage: any;
  fileName: string = '';
  folderForm!: FormGroup;
  questionForm!: FormGroup;
  exportQuestionsForm!: FormGroup;
  folderIdToExport!: string;
  QuestionIdsToExport!: string;
  public fromPage: string = 'Question';
  public searchQuestionCategoryId: number = 0;
  currentSelectedQuestionId: number = 0;
  currentSelectedFolderId: number = 0;
  public currentSelectedQuestionName: string = '';
  public currentSelectedFolderName: string = '';
  copyQuestionForm!: FormGroup;
  copyFolderForm!: FormGroup;
  successOrFailureMessage: string = '';
  public oktaTokenDetails!: oktaToken;

  public gridPageSize = 10;
  public gridSkip = 0;

  // ViewChild references for modals opened from grid actions
  @ViewChild('importModal') importModalTemplate!: TemplateRef<any>;
  @ViewChild('exportQuestionsModel') exportModalTemplate!: TemplateRef<any>;
  @ViewChild('deleteQuestionConfirmation') deleteModalTemplate!: TemplateRef<any>;

  // ISG Grid configurations for consistent styling
  folderGridConfig: Partial<IsgGridConfig> = {
    height: '550px',
    pagination: true,
    pageSize: 10,
    rowSelection: 'multiple',
    autoSizeColumns: true
  };

  exportGridConfig: Partial<IsgGridConfig> = {
    height: '250px',
    pagination: false,
    rowSelection: 'multiple',
    autoSizeColumns: true
  };

  // Loading state for export grid
  exportGridLoading: boolean = false;

  // Export grid API reference
  private exportGridApi: any = null;

  constructor(
    @Inject(OKTA_AUTH) private oauth: OktaAuth,
    protected http: HttpClient,
    private EncrDecr: EncrDecrService,
    private _router: Router,
    private formBuilder: FormBuilder,
    private commonService: CommonService,
    private renderer: Renderer2,
    private _date: DatePipe,
    private modalService: NgbModal,
    private questionSerivce: QuestionService,
    @Inject('BASE_URL') baseUrl: string // <-- add this
  ) {
    super(http, oauth);
    this.myAppUrl = baseUrl; // <-- add this
  }
  ngOnInit() {
    this.getMainQuestionList();
    this.initiateForms();
  }

  initiateForms() {
    this.copyQuestionForm = this.formBuilder.group({
      'question': new FormControl('', Validators.required),
      sourceQuestionId: 0,
    });

    this.copyFolderForm = this.formBuilder.group({
      'folder': new FormControl('', Validators.required),
      sourceFolderId: 0,
    });
  }

  openImportModal(template: TemplateRef<any>) {
    this.modalRef = this.modalService.open(template);
    this.questionSerivce.ImportNew().subscribe({
      next: (result: question) => {
        this.questionNew = result;
      },
      error: (err) => {
        console.error('ImportNew error:', err);
      }
    });
  }

  openExportQuestionModal(template: TemplateRef<any>) {
    this.modalRef = this.modalService.open(template);
    this.ExportNew();
  }
  openAddFolderModal(template: TemplateRef<any>) {
    this.modalRef = this.modalService.open(template);
    this.CreateFolder();
  }
  openDeleteFolderModal(template: TemplateRef<any>) {
    this.modalRef = this.modalService.open(template);
  }

  // Methods for row-level actions in grid
  openImportModalForRow() {
    if (this.importModalTemplate) {
      // Clear file and initialize form with selected folder
      this.file = null;
      this.fileName = "No File Chosen";
      this.questionForm = this.formBuilder.group({
        folderId: this.currentSelectedFolderId,
        fileControl: new FormControl(null),
        folderName: this.currentSelectedFolderName,
        listofFolders: [],
        mainQuestions: [],
        childQuestions: [],
      });

      this.modalRef = this.modalService.open(this.importModalTemplate);
    }
  }

  openExportModalForRow() {
    if (this.exportModalTemplate) {
      // Clear previous data and show loading
      this.exportQuestionList = [];
      this.questionsToExport = [];
      this.exportGridLoading = true;

      // Pre-select the current folder
      this.exportQuestionsForm = this.formBuilder.group({
        folderId: this.currentSelectedFolderId,
      });

      // Open modal (medium-large size)
      this.modalRef = this.modalService.open(this.exportModalTemplate, { size: 'lg' });

      // Load questions for the selected folder
      this.questionSerivce.getMainQuestionList(this.currentSelectedFolderId.toString()).subscribe({
        next: (result: any) => {
          // Filter to only show non-folder items (actual questions)
          this.exportQuestionList = result.filter((x: { questionType: string; }) => x.questionType !== 'Folder');
          this.exportGridLoading = false;

          // If grid API is available, set data directly
          if (this.exportGridApi) {
            this.exportGridApi.setGridOption('rowData', this.exportQuestionList);
            if (this.exportQuestionList.length === 0) {
              this.exportGridApi.showNoRowsOverlay();
            } else {
              this.exportGridApi.hideOverlay();
            }
          }
        },
        error: (err) => {
          console.error('Error loading questions:', err);
          this.exportGridLoading = false;
          if (this.exportGridApi) {
            this.exportGridApi.showNoRowsOverlay();
          }
        }
      });
    }
  }

  openDeleteModalForRow() {
    if (this.deleteModalTemplate) {
      this.modalRef = this.modalService.open(this.deleteModalTemplate);
    }
  }

  redirectToSearch() {
    this._router.navigate(['/questionSearch'], { queryParams: { searchQuestionCategoryId: this.searchQuestionCategoryId } });
  }
  removeCacheData() {
    this.questionSerivce.removeQuestionListCache().subscribe({
      next: (result: any) => {
        console.log('Remove Question List Cache Status: ', result);
      }
    });
  }

  ExportNew() {

    this.exportQuestionsForm = this.formBuilder.group({
      folderId: 0,
    });
    let workspaceId = this.EncrDecr.get(localStorage.getItem('workspaceId') ?? '');
    let tmpFolderId = "0";

    this.questionSerivce.getMainQuestionList().subscribe({
      next: (result: any) => {
        this.exportQuestionList = result;
      }
    });

  }

  AddNew() {
    this.file = null;
    this.fileName = "No File Chosen";
    this.questionForm = this.formBuilder.group({
      folderId: new FormControl(null, Validators.required),
      fileControl: new FormControl(null),
      folderName: '',
      listofFolders: [],
      mainQuestions: [],
      childQuestions: [],

    });
    this.questionSerivce.ImportNew().subscribe({
      next: (result: question) => {
        this.questionNew = result;
      },
      error: (err) => {
        console.error('ImportNew error:', err);
      }
    });
  }

  // Update onChange to accept event and safely extract value
  onChange(event: Event) {
    const target = event.target as HTMLSelectElement | null;
    const folderId = target ? target.value : '';
    let paramValue: string = '';
    let workspaceId = this.EncrDecr.get(localStorage.getItem('workspaceId') ?? '');
    if (folderId && typeof folderId === 'string' && folderId !== '0') {
      const split = folderId.split(':');
      paramValue = split.length > 1 ? split[1].trim() : folderId;
    } else {
      paramValue = folderId;
    }
    this.questionSerivce.getMainQuestionList().subscribe({
      next: (result: mainQuestion[]) => {
        this.exportQuestionList = result;
      },
      error: (err) => {
        console.error('ExportQuestionList error:', err);
      }
    });

  }

  CloseExportQuestionsForm() {
    this.exportQuestionsForm.reset();
  }

  CreateFolder() {
    this.folderForm = this.formBuilder.group({
      'folderName': new FormControl('', Validators.compose([Validators.required, this.noWhitespaceValidator])),
      folderId: 0,
    });
  }

  public noWhitespaceValidator(control: import('@angular/forms').AbstractControl): { [key: string]: boolean } | null {
    const isWhitespace = (control.value || '').trim().length === 0;
    const isValid = !isWhitespace;
    return isValid ? null : { 'whitespace': true };
  }

  incomingfile(event: any) {
    this.file = event.target.files[0];
    this.fileName = this.file ? this.file.name : '';
    this.Import();
  }

  getMainQuestionList() {
    this.questionSerivce.getMainQuestionList().subscribe({
      next: (result: any[]) => {
        this.mainQuestionList = result;
        this.folderList = result.filter((x: { questionType: string; }) => x.questionType == 'Folder');
        this.questionList = result.filter((x: { questionType: string; }) => x.questionType != 'Folder');
      }
    })
    this.hideMessage();
  }
  saveFolder() {
    this.getMainQuestionList();
    var existFolder = this.folderList.find(x => x.question == this.folderForm.controls.folderName.value && x.questionType == "Folder");
    let workspaceId = this.EncrDecr.get(localStorage.getItem('workspaceId') ?? '');
    let userId = this.EncrDecr.get(localStorage.getItem('userId') ?? '')

    if (existFolder == undefined) {
      let model = { "model=": JSON.stringify(this.folderForm.value), 'workspaceId=': workspaceId, 'userId=': userId };

      this.questionSerivce.saveFolder(this.folderForm.value).subscribe({
        next: (result: any[]) => {
          if (result) {
            this.getMainQuestionList();
          }
          this.folderList = result.filter((x) => x.questionType == 'Folder');
          this.folderForm.reset();
          this.showMessage("Folder Created Successfully");
          this.messageTimeout();
        }
      })

    }
    else {
      this.showMessage("Folder Name Already Exists");
      this.messageTimeout();
    }
  }
  showMessage(params: any) {
    var divMessage = document.getElementById('messageContainer');
    if (divMessage) divMessage.style.display = "block";
    var message = document.getElementById('message');
    if (message) message.innerText = params;
  }

  hideMessage() {
    var divMessage = document.getElementById('messageContainer');
    if (divMessage) divMessage.style.display = "none";
    var message = document.getElementById('message');
    if (message) message.innerText = '';
  }
  saveQuestion() {
    try {
      this.questionForm.patchValue({ folderId: this.questionForm.controls.folderId.value, mainQuestions: this.questionForm.controls.mainQuestions.value, childQuestions: this.questionForm.controls.childQuestions.value, folderName: "", listofFolders: [{ folderId: 0, folderName: "" }] });
      let workspaceId = this.EncrDecr.get(localStorage.getItem('workspaceId') ?? '');
      let data = { 'modelData': this.questionForm.value, 'workspaceId=': workspaceId };



      this.questionSerivce.saveQuestion(this.questionForm.value).subscribe({
        next: (result: any[]) => {
          if (result) {
            this.mainQuestionList = result;
            this.questionList = result.filter((x: { questionType: string; }) => x.questionType != 'Folder');
            this.file = null;
            this.fileName = "No File Chosen";
            this.questionForm.reset();
            this.showMessage("Questions Imported Successfully");
            this.messageTimeout();
          } else {
            this.questionForm.reset();
            this.file = null;
            this.fileName = "No File Chosen";
            this.showMessage("Error while importing Questions");
            this.messageTimeout();
          }
        }
      })

    }
    catch (e) {

    }
  }
  messageTimeout() {
    window.setTimeout(() => {
      this.hideMessage();
    }, 3200);
  }
  CloseFolderForm() {
    this.folderForm.reset();
  }
  CloseQuestionForm() {
    this.questionForm.reset();
  }
  Import() {
    let fileReader = new FileReader();

    fileReader.onload = (e) => {
      this.arrayBuffer = fileReader.result;
      var data = new Uint8Array(this.arrayBuffer);
      var arr = new Array();
      for (var i = 0; i != data.length; ++i) arr[i] = String.fromCharCode(data[i]);
      var bstr = arr.join("");
      var workbook = XLSX.read(bstr, { type: "binary" });
      var first_sheet_name = workbook.SheetNames[0];
      var firstworksheet = workbook.Sheets[first_sheet_name];
      var mainsheet = XLSX.utils.sheet_to_json(firstworksheet, { raw: true });
      let mainQuestionSheet: any[] = mainsheet;
      var second_sheet_name = workbook.SheetNames[1];
      var secondworksheet = workbook.Sheets[second_sheet_name];
      var childsheet = XLSX.utils.sheet_to_json(secondworksheet, { raw: true });
      let childQuestionSheet: any[] = childsheet;
      this.questionForm.patchValue({ folderId: this.questionForm.controls.folderId.value, mainQuestions: mainQuestionSheet, childQuestions: childQuestionSheet, folderName: "", listofFolders: [{ folderId: 0, folderName: "" }] });
    }
    if (this.file) fileReader.readAsArrayBuffer(this.file);
  }

  linkRenderer(params: any) {

    if (params.data.questionType == "Folder") {
      const element = this.renderer.createElement('a');
      const ielement = this.renderer.createElement('i');
      this.renderer.setAttribute(ielement, 'class', 'fa  fa-folder');
      this.renderer.appendChild(element, ielement);
      const attr = this.renderer.createText(" " + params.data.question);

      this.renderer.appendChild(element, attr);
      //this.renderer.setAttribute(element, 'href', "#");
      this.renderer.setAttribute(element, 'data-toggle', "modal");
      this.renderer.setAttribute(element, 'class', 'form-control-label');
      this.renderer.setAttribute(element, 'value', params.data.questionReference);
      var questionReference = params.data.questionReference;
      var question = params.data.question;
      this.renderer.listen(element, 'click', () => {
        let parameter = "?folderId=" + params.data.questionReference;
        this._router.navigate(['viewquestions'], { queryParams: { questionReference: questionReference, question: question } });

      });
      return element;
    }
    else {

      const element = this.renderer.createElement('a');
      const text = this.renderer.createText(params.data.question);
      this.renderer.setAttribute(element, 'class', "anchor-cursor");
      this.renderer.appendChild(element, text);

      let questionId = params.data.questionReference;
      let folderId = -1;
      let type = params.data.questionType;
      this.renderer.listen(element, 'click', () => {

        if (type == 'Matrix')
          this._router.navigate(['/questionmatrix'], { queryParams: { 'questionId': questionId, 'folderId': folderId } });
        else if (type == 'Description')
          this._router.navigate(['/descriptionType'], { queryParams: { 'questionId': questionId, 'folderId': folderId } });
        else if (type == 'TextInput')
          this._router.navigate(['/inputType'], { queryParams: { 'questionId': questionId, 'folderId': folderId } });
        else if (type == 'Picklist')
          this._router.navigate(['/picklistquestion'], { queryParams: { 'questionId': questionId, 'folderId': folderId } });
        else if (type == 'MultipleResponse')
          this._router.navigate(['/multipleresponse'], { queryParams: { 'questionId': questionId, 'folderId': folderId } });
        else if (type == 'MultipleChoice')
          this._router.navigate(['/multiplechoice'], { queryParams: { 'questionId': questionId, 'folderId': folderId } });
        else if (type == 'Slider')
          this._router.navigate(['/slider'], { queryParams: { 'questionId': questionId, 'folderId': folderId } });
        else if (type == 'ConstantSum')
          this._router.navigate(['/constantsum'], { queryParams: { 'questionId': questionId, 'folderId': folderId } });
        else if (type == 'RankingSort')
          this._router.navigate(['/rankingsort'], { queryParams: { 'questionId': questionId, 'folderId': folderId } });
        else if (type == 'DateTime')
          this._router.navigate(['/datetimeType'], { queryParams: { 'questionId': questionId, 'folderId': folderId } });

      });

      return element;
    }
  }
  BackUrl() {
    this._router.navigate(['home']);

  }
  onRowChecked(params: any) {
    // Check if row is selected using params.node.selected
    const itemKey = params.data.questionReference + '~' + params.data.questionType;
    if (params.node?.selected) {
      // Add only if not already in array
      if (!this.questionsToDelete.includes(itemKey)) {
        this.questionsToDelete.push(itemKey);
      }
    }
    else {
      // Remove from array
      const index = this.questionsToDelete.indexOf(itemKey);
      if (index !== -1) this.questionsToDelete.splice(index, 1);
    }
  }
  onCellClicked(params: any, copyFolderTemplate: TemplateRef<any>, editFolderTemplate: TemplateRef<any>) {
    // Safely get click element class
    const clickElement = params.eventPath?.[0]?.classList?.[1]?.toString() || '';

    // Handle actions based on clicked icon (edit/copy actions are handled in QuestionActionsRenderer)
    switch (clickElement) {
      case 'fa-edit':
        this.modalRef = this.modalService.open(editFolderTemplate);
        this.folderForm = this.formBuilder.group({
          folderName: params.data.question,
          folderId: params.data.questionReference,
        });
        break;
      case 'fa-copy':
        this.modalRef = this.modalService.open(copyFolderTemplate);
        break;
    }
  }
  deleteQuestions() {
    let workspaceId = this.EncrDecr.get(localStorage.getItem('workspaceId') ?? '') || '2';

    // Remove duplicates from questionsToDelete
    const uniqueQuestions = [...new Set(this.questionsToDelete)];

    if (uniqueQuestions.length === 0) return '';

    // Build comma-separated list without trailing comma
    const concatenated = uniqueQuestions.join(',');
    const model = concatenated + "/" + workspaceId;

    this.questionSerivce.deleteQuestion(model).subscribe({
      next: (result: { listOfMainQuestions: any[]; deletedStatus: string; }) => {
        this.mainQuestionList = result.listOfMainQuestions;
        this.folderList = result.listOfMainQuestions.filter((x: { questionType: string; }) => x.questionType == 'Folder');
        this.questionList = result.listOfMainQuestions.filter((x: { questionType: string; }) => x.questionType != 'Folder');
        if (result.deletedStatus.toLowerCase() == "yes") {
          this.showMessage("Question/Folder Deleted Successfully");
        }
        else if (result.deletedStatus.toLowerCase() == "no") {
          this.showMessage("Cannot delete Question/Folder because there may be some Survey/Section dependency. ");
        }
        else {
          this.showMessage("There may be some exception error");
        }
        this.messageTimeout();
        this.questionsToDelete = [];
      },
      error: (err) => {
        console.error('Delete error:', err);
        this.showMessage("Error occurred while deleting. Please try again.");
        this.messageTimeout();
        this.questionsToDelete = [];
      }
    })
    return '';
  }

  exportQuestions() {
    this.QuestionIdsToExport = '';

    var concatenated = "";
    for (var i = 0; i <= this.questionsToExport.length - 1; i++) {
      concatenated = concatenated + this.questionsToExport[i] + ",";
    }
    if (concatenated != "") {
      this.QuestionIdsToExport = concatenated;
    }
    //let parameters = "?folderId=" + this.exportQuestionsForm.controls.folderId.value + "&QuestionIds=" + this.QuestionIdsToExport;

    this.questionSerivce.getExportQuestion(this.exportQuestionsForm.controls.folderId.value, this.QuestionIdsToExport).subscribe({
      next: (result: { mainQuestions: mainQuestionsToExport[]; childQuestions: childQuestionsToExprot[]; }) => {
        this.mainQuestionListToExport = result.mainQuestions;
        this.childQuestionListToExport = result.childQuestions;
        this.exportToExcel();
      }
    })
  }

  AddQuestionsdescription() {
    this._router.navigate(['/create-desc-input']);
  }

  AddQuestionsType() {
    this._router.navigate(['/create-input-type']);
  }

  exportToExcel() {
    const mainQuestionHeader = ["QuestionReference", "Question", "QuestionType", "HideRowHeader", "SliderDefaultValue", "SliderSchemaId", "Width", "ShortName"];
    const mainQuestions = this.mainQuestionListToExport;

    // Create worksheet data
    const mainSheetData = [mainQuestionHeader];
    mainQuestions.forEach(d => {
      mainSheetData.push([
        //d.questionId,
        d.question,
        d.questionType,
        //d.hideRowHeader ? 1 : 0,
        //d.sliderDefaultValue,
        //d.sliderSchemaId,
        d.width,
        d.shortName
      ]);
    });

    const childQuestionHeader = ["QuestionId", "Description", "Type", "ColumnReference",
      "RowReference", "QuestionReference", "DisplayOrder", "IsMandatory", "ControlType",
      "DataType", "PickLIstReferenceId", "Min", "Max", "Size", "IsEnabled", "Width", "Weightage", "IsTextBoxRequired", "EvaluateAndExit", "HeaderDescription", "HeaderValue", "OptionShortName", "HoverText"];
    const childSheetData = [childQuestionHeader];
    this.childQuestionListToExport.forEach(d => {
      childSheetData.push([
        String(d.questionId),
        d.description,
        d.type,
        String(d.columnReference > 0 ? d.columnReference : ''),
        String(d.rowReference > 0 ? d.rowReference : ''),
        String(d.questionReference > 0 ? d.questionReference : ''),
        String(d.displayOrder > 0 ? d.displayOrder : ''),
        String(d.isMandatory),
        d.controlType,
        d.dataType,
        String(d.pickListReferenceId > 0 ? d.pickListReferenceId : ''),
        String(d.minValue >= 0 ? d.minValue : ''),
        String(d.maxValue > 0 ? d.maxValue : ''),
        String(d.size),
        String(d.isEnabled == null || d.isEnabled.toString().toLowerCase() == "true" || d.isEnabled.toString() == "" ? true : false),
        String(d.width > 0 ? d.width : ''),
        d.weightage,
        String(d.isTextBoxRequired == null || d.isTextBoxRequired.toString().toLowerCase() == "false" || d.isTextBoxRequired.toString() == "" || d.isTextBoxRequired.toString() == "0" ? false : true),
        String(d.evaluateAndExit == null || d.evaluateAndExit.toString().toLowerCase() == "false" || d.evaluateAndExit.toString() == "" || d.evaluateAndExit.toString() == "0" ? false : true),
        d.headerDescription,
        d.headerValue,
        d.optionShortName,
        d.hoverText
      ]);
    });

    // Create workbook
    const wb = XLSX.utils.book_new();
    const wsMain = XLSX.utils.aoa_to_sheet(mainSheetData);
    XLSX.utils.book_append_sheet(wb, wsMain, 'MainQuestions');
    const wsChild = XLSX.utils.aoa_to_sheet(childSheetData);
    XLSX.utils.book_append_sheet(wb, wsChild, 'ChildQuestions');
    XLSX.writeFile(wb, 'QuestionDefinition.xlsx');
    this.showMessage("File Exported successfully");
    this.messageTimeout();
  }

  folder1columnDefs: any[] = [
    // Checkbox column hidden for now
    // { headerName: '', field: '', width: 35, suppressMenu: true, resizable: true, checkboxSelection: true, headerCheckboxSelection: true, suppressSorting: true },
    // Serial number column
    //{ headerName: 'S.No', width: 70, resizable: false, sortable: false, filter: false, valueGetter: (params: any) => params.node.rowIndex + 1 },
    { headerName: 'Folder Name', field: 'question', cellRenderer: this.linkRenderer.bind(this), resizable: true },
    // Type column hidden
     //{ headerName: 'Type', field: 'questionType', width: 100, resizable: true },
    { headerName: 'Created Date', field: 'createdDate', width: 150, resizable: true, valueFormatter: dateValueFormatter },
    { headerName: 'Created By', field: 'createdByName', width: 160, resizable: true },
    // Actions column moved to last position with Import, Export, Delete icons
    { headerName: 'Actions', field: 'value', width: 150, cellRenderer: this.QuestionActionsRenderer.bind(this), resizable: true, pinned: 'right' }
  ];

  columnDefs = [
    {
      headerName: '', field: '', width: 40, suppressMenu: true, resizable: true, checkboxSelection: true, headerCheckboxSelection: true, suppressSorting: true
    },
    /*{ headerName: 'Preview', field: 'value', width: 55, cellRenderer: this.PreviewQuestionCellRenderer.bind(this) },*/
    { headerName: 'Actions', field: 'value', width: 90, cellRenderer: this.QuestionActionsRenderer.bind(this), resizable: true },
    //{ headerName: 'Language Settings', field: 'value', width: 55, cellRenderer: this.QuestionLanguageSettingsRenderer.bind(this) },
    { headerName: 'QuestionId', field: 'questionReference', hide: true, resizable: true },
    //{ headerName: 'Copy', width: 55, cellRenderer: this.copyImageRenderer.bind(this) },
    { headerName: 'Question Text', field: 'question', cellRenderer: this.linkRenderer.bind(this), resizable: true },
    { headerName: 'Type', field: 'questionType', width: 130, resizable: true },
    { headerName: 'Created Date', field: 'createdDate', width: 150, resizable: true, valueFormatter: dateValueFormatter }


  ];

  copyImageRenderer(params: any) {
    if (params.data.questionType !== "Folder") {
      const element = this.renderer.createElement('a');
      const elementI = this.renderer.createElement('i');
      element.setAttribute('data-toggle', 'modal');
      element.setAttribute('href', '#copyQuestionModel');
      elementI.setAttribute('class', 'fa  fa-copy anchor-cursor');
      this.renderer.appendChild(element, elementI);

      this.renderer.listen(element, 'click', () => {
        this.currentSelectedQuestionId = params.data.questionReference;
        this.currentSelectedQuestionName = params.data.question;


        this.copyQuestionForm.patchValue({
          sourceQuestionId: params.data.questionReference,
          //serviceLineId: -1,
          question: 'Copy of ' + params.data.question,
        });
      });
      return element;
    }
  }

  CopyQuestion() {
    let headers = new HttpHeaders({
      Authorization: 'Bearer ' + this.oktaTokenDetails.accessToken,
      'Content-Type': 'application/json'
    });
    
    if (this.mainQuestionList.filter(x => x.question == this.copyQuestionForm.controls.question.value && x.questionType != "Folder").length == 0) {
      let data = JSON.stringify(this.copyQuestionForm.value);
      this.questionSerivce.copyQuestion(data,this.folderIdToExport)
        .subscribe(result => {
          this.questionList = result.questionList;
          if (result.status == 'Yes') {
            this.showMessage("Question has been copied successfully.");
          }
          else {
            this.showMessage("Error occurred while trying to copy the specified question.Please try again..");
          }
          this.messageTimeout();

          this.mainQuestionList = result.questionList;
          this.folderList = result.filter((x: { questionType: string; }) => x.questionType == 'Folder');
          this.questionList = result.filter((x: { questionType: string; }) => x.questionType != 'Folder');
          this.copyQuestionForm.reset();
        }, error => console.error(error));

    }

    else {
      this.showMessage("Question Already Exists");
      this.messageTimeout();
    }
  }

  CopyFolder() {
    this.getMainQuestionList();
    var existFolder = this.mainQuestionList.find(x => x.question == this.copyFolderForm.controls.folder.value && x.questionType == "Folder");
    let workspaceId = this.EncrDecr.get(localStorage.getItem('workspaceId') ?? '');
    let userId = this.EncrDecr.get(localStorage.getItem('userId') ?? '');

    if (existFolder == undefined) {
      let model = { "model=": JSON.stringify(this.copyFolderForm.value), 'workspaceId=': workspaceId, 'userId=': userId };


      this.questionSerivce.copyFolder(this.copyFolderForm.value).subscribe({
        next: (result: any[]) => {
          this.mainQuestionList = result;
          this.folderList = result.filter((x: { questionType: string; }) => x.questionType == 'Folder');
          this.questionList = result.filter((x: { questionType: string; }) => x.questionType != 'Folder');
          this.copyFolderForm.reset();
          this.showMessage("Folder Created Successfully");
          this.messageTimeout();
        }
      })
    }
    else {
      this.showMessage("Folder Name Already Exists");
      this.messageTimeout();
    }


  }

  onQuestionGridReady(params: any) {
    params.api.sizeColumnsToFit();
  }

  exportColumnDefs: any[] = [
    { headerName: '', field: 'rowSelect', width: 40, suppressMenu: true, checkboxSelection: true, headerCheckboxSelection: true, suppressSorting: true, resizable: true },
    { headerName: 'QuestionId', field: 'questionReference', hide: true },
    { headerName: 'Question Text', width: 650, field: 'question', resizable: true },
    { headerName: 'Type', width: 200, field: 'questionType', resizable: true },
  ];
  onExportQuestionGridReady(params: any) {
    this.exportGridApi = params.api;
    params.api.sizeColumnsToFit();

    // If data is already loaded, set it now
    if (this.exportQuestionList && this.exportQuestionList.length > 0) {
      params.api.setGridOption('rowData', this.exportQuestionList);
      params.api.hideOverlay();
    } else if (this.exportGridLoading) {
      params.api.showLoadingOverlay();
    }
  }
  onExportQuestionRowChecked(params: any) {
    if (params.node.selected) {
      this.questionsToExport.push(params.data.questionReference);
    }
    else {
      var index = this.questionsToExport.indexOf(params.data.questionReference);
      if (index !== -1) this.questionsToExport.splice(index, 1);
    }
  }


  QuestionActionsRenderer(params: any) {
    const mainElement = this.renderer.createElement('div');
    this.renderer.setStyle(mainElement, 'display', 'flex');
    this.renderer.setStyle(mainElement, 'align-items', 'center');
    this.renderer.setStyle(mainElement, 'gap', '4px');

    var questionReference = params.data.questionReference;
    var question = params.data.question;

    // Edit Action (for folders)
    if (params.data.questionType == "Folder") {
      const editAnchor = this.renderer.createElement('a');
      const editIcon = this.renderer.createElement('i');
      editIcon.setAttribute('class', 'fa fa-edit anchor-cursor p-1');
      editIcon.setAttribute('title', 'Edit Folder Name');
      this.renderer.appendChild(editAnchor, editIcon);
      this.renderer.appendChild(mainElement, editAnchor);
      this.renderer.listen(editAnchor, 'click', () => {
        let parameter = "?folderId=" + params.data.questionReference;
        this.questionSerivce.getEditFolder(parameter).subscribe({
          next: (response: { folderName: any; folderId: any; }) => {
            this.folderForm = this.formBuilder.group({
              folderName: response.folderName,
              folderId: response.folderId,
            });
          }
        });
      });

      // Copy Folder Action
      const copyAnchor = this.renderer.createElement('a');
      const copyIcon = this.renderer.createElement('i');
      copyIcon.setAttribute('class', 'fa fa-copy anchor-cursor p-1');
      copyIcon.setAttribute('title', 'Copy Folder');
      this.renderer.appendChild(copyAnchor, copyIcon);
      this.renderer.appendChild(mainElement, copyAnchor);
      this.renderer.listen(copyAnchor, 'click', () => {
        this.currentSelectedFolderId = params.data.questionReference;
        this.currentSelectedFolderName = params.data.question;
        this.copyFolderForm.patchValue({
          sourceFolderId: params.data.questionReference,
          folder: 'Copy of ' + params.data.question,
        });
      });
    }

    // Preview and Language Settings for questions (non-folder)
    if (params.data.questionType !== "Folder") {
      const previewAnchor = this.renderer.createElement('a');
      const previewIcon = this.renderer.createElement('i');
      previewIcon.setAttribute('class', 'fa fa-eye anchor-cursor p-1');
      previewIcon.setAttribute('title', 'Preview Question');
      this.renderer.appendChild(previewAnchor, previewIcon);
      this.renderer.appendChild(mainElement, previewAnchor);
      this.renderer.listen(previewAnchor, 'click', () => {
        this._router.navigate(['/previewquestion'], { queryParams: { questionId: questionReference, folderId: "0", folderName: "" } });
      });

      // Language Settings
      const langSettingsAnchor = this.renderer.createElement('a');
      const langSettingsIcon = this.renderer.createElement('i');
      langSettingsIcon.setAttribute('class', 'fa fa-cogs anchor-cursor p-1');
      langSettingsIcon.setAttribute('title', 'Question Language Settings');
      this.renderer.appendChild(langSettingsAnchor, langSettingsIcon);
      this.renderer.appendChild(mainElement, langSettingsAnchor);
      this.renderer.listen(langSettingsAnchor, 'click', () => {
        this._router.navigate(['/questionlanguagesettings'], { queryParams: { questionId: questionReference, folderId: "0", folderName: "" } });
      });

      // Copy Question
      const copyQuesAnchor = this.renderer.createElement('a');
      const copyQuesIcon = this.renderer.createElement('i');
      copyQuesIcon.setAttribute('class', 'fa fa-copy anchor-cursor p-1');
      copyQuesIcon.setAttribute('title', 'Copy Question');
      copyQuesAnchor.setAttribute('data-toggle', 'modal');
      copyQuesAnchor.setAttribute('href', '#copyQuestionModel');
      this.renderer.appendChild(copyQuesAnchor, copyQuesIcon);
      this.renderer.appendChild(mainElement, copyQuesAnchor);
      this.renderer.listen(copyQuesAnchor, 'click', () => {
        this.currentSelectedQuestionId = params.data.questionReference;
        this.currentSelectedQuestionName = params.data.question;
        this.copyQuestionForm.patchValue({
          sourceQuestionId: params.data.questionReference,
          question: 'Copy of ' + params.data.question,
        });
      });
    }

    // Import Action - opens file chooser popup
    const importAnchor = this.renderer.createElement('a');
    const importIcon = this.renderer.createElement('i');
    importIcon.setAttribute('class', 'fa fa-upload anchor-cursor p-1');
    importIcon.setAttribute('title', 'Import Questions');
    importIcon.setAttribute('style', 'color: #28a745;');
    this.renderer.appendChild(importAnchor, importIcon);
    this.renderer.appendChild(mainElement, importAnchor);
    this.renderer.listen(importAnchor, 'click', () => {
      this.currentSelectedFolderId = params.data.questionReference;
      this.currentSelectedFolderName = params.data.question;
      this.openImportModalForRow();
    });

    // Export Action - opens export popup
    const exportAnchor = this.renderer.createElement('a');
    const exportIcon = this.renderer.createElement('i');
    exportIcon.setAttribute('class', 'fa fa-download anchor-cursor p-1');
    exportIcon.setAttribute('title', 'Export Questions');
    exportIcon.setAttribute('style', 'color: #17a2b8;');
    this.renderer.appendChild(exportAnchor, exportIcon);
    this.renderer.appendChild(mainElement, exportAnchor);
    this.renderer.listen(exportAnchor, 'click', () => {
      this.currentSelectedFolderId = params.data.questionReference;
      this.currentSelectedFolderName = params.data.question;
      this.openExportModalForRow();
    });

    // Delete Action - at the end
    const deleteAnchor = this.renderer.createElement('a');
    const deleteIcon = this.renderer.createElement('i');
    deleteIcon.setAttribute('class', 'fa fa-trash anchor-cursor p-1');
    deleteIcon.setAttribute('title', 'Delete');
    deleteIcon.setAttribute('style', 'color: #dc3545;');
    this.renderer.appendChild(deleteAnchor, deleteIcon);
    this.renderer.appendChild(mainElement, deleteAnchor);
    this.renderer.listen(deleteAnchor, 'click', () => {
      this.questionsToDelete = [params.data.questionReference + '~' + params.data.questionType];
      this.openDeleteModalForRow();
    });

    return mainElement;
  }

  PreviewQuestionCellRenderer(params: any) {
    const eSpan = this.renderer.createElement('a');
    const ielement = this.renderer.createElement('i');
    this.renderer.appendChild(eSpan, ielement);
    this.renderer.setAttribute(eSpan, 'class', 'fa  fa-eye anchor-cursor');
    var questionReference = params.data.questionReference;
    var question = params.data.question;
    if (params.data.questionType == "Folder") {
      this.renderer.listen(eSpan, 'click', () => {
        this._router.navigate(['viewquestions'], { queryParams: { questionReference: questionReference, question: question } });
      });
    }
    else {
      this.renderer.listen(eSpan, 'click', () => {
        this._router.navigate(['/previewquestion'], { queryParams: { questionId: questionReference, folderId: "0", folderName: "" } });
      });
    }
    return eSpan;

  }

  QuestionLanguageSettingsRenderer(params: any) {
    if (params.data.questionType !== "Folder") {
      const eSpan = this.renderer.createElement('a');
      const ielement = this.renderer.createElement('i');
      this.renderer.appendChild(eSpan, ielement);
      this.renderer.setAttribute(eSpan, 'class', 'fa fa-cogs anchor-cursor');
      var questionReference = params.data.questionReference;
      var question = params.data.question;
      this.renderer.listen(eSpan, 'click', () => {
        this._router.navigate(['/questionlanguagesettings'], { queryParams: { questionId: questionReference, folderId: "0", folderName: "" } });
      });
      return eSpan;
    }


  }

  get pagedFolderList(): mainQuestion[] {
    return this.folderList.slice(this.gridSkip, this.gridSkip + this.gridPageSize);
  }

  onGridPageChange(event: any) {
    this.gridSkip = event.skip;
    this.gridPageSize = event.pageSize;
  }

  // onFolderRowClicked(event: any) {
  //   // Set the selected folder info if needed
  //   this.currentSelectedFolderId = event.data.questionReference;
  //   this.currentSelectedFolderName = event.data.question;

  //   // Patch the form if you want to prefill the modal
  //   this.copyFolderForm.patchValue({
  //     sourceFolderId: event.data.questionReference,
  //     folder: 'Copy of ' + event.data.question,
  //   });

  //   // Open the modal
  //   //this.modalService.open(this.copyFolderModel);
  // }
}

